var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360.512 360.512",
    style: {
      enableBackground: "new 0 0 360.512 360.512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.132,100.872V51.25h-59.375V0h-15v51.25h-59.375v49.622H89.196v259.64h182.121v-259.64 C271.317,100.872,247.132,100.872,247.132,100.872z M128.382,66.25h103.75v34.622h-103.75V66.25z M256.317,345.512H104.196 v-229.64h9.186h133.75h9.186L256.317,345.512L256.317,345.512z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.382,
    y: 142.756,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.756,
    y: 142.756,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.13,
    y: 142.756,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.504,
    y: 142.756,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.382,
    y: 201.923,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.756,
    y: 201.923,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.13,
    y: 201.923,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.504,
    y: 201.923,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.382,
    y: 261.089,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.756,
    y: 261.089,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.13,
    y: 261.089,
    width: 15,
    height: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.504,
    y: 261.089,
    width: 15,
    height: 33.75
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingSvgrepoCom);
export default __webpack_public_path__ + "static/media/building-svgrepo-com.07b48487b29b99c07a80bc590d05f3a0.svg";
export { ForwardRef as ReactComponent };